import React, { useState, useEffect } from "react";
import ScrapingService from "../services/scraping.service";

export default function useScrapingCredentials(provider) {
    const [credentials, setCredentials] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCredentials = async () => {
            try {
                setLoading(true);
                const credentials = await ScrapingService.getAvailableCrendentials(provider);
                setCredentials(credentials);
            } catch (error) {
                setLoading(false);
            } finally {
                setLoading(false);
            }
        }
        fetchCredentials();
    }, [provider]);

    return { credentials, loading };
}
